<script setup>
import {clickOutSide as vClickOutside} from "@/vClickOutside.js";
import {getLang, getLangs} from "@/constants.js";
import {onSelectLang} from "@/helper.js";
import {ref} from "vue";
import MaskIcon from "@/Components/MaskIcon.vue";

const showLangs = ref(false);
const lang = getLang()
const hideLangs = () => {
    if (showLangs.value) {
        showLangs.value = false
    }
}

</script>
<template>
    <div v-click-outside="hideLangs" dusk="lang-switch" class="relative" @click="showLangs = !showLangs">
        <div class="flex gap-2 text-sm items-center group">
            <ion-icon name="globe"
                      class="text-xl align-middle group-hover:text-blue-400 transition-colors" style="width: 20px; height: 20px"></ion-icon>
            <span class="cursor-pointer group-hover:text-blue-400 transition-colors">{{
                    lang.short
                }}</span>
            <MaskIcon src="/assets/icons/arrow.svg"
                class="w-3 h-3 !bg-white group-hover:!bg-blue-400 transition-colors duration-100"/>
        </div>
        <div v-if="showLangs" class="absolute z-10 top-10">
            <div class=" flex items-center px-2.5 bg-deep-blue">
                <ul>
                    <li v-for="itemLang in getLangs()"
                        class="py-1.5 hover:text-blue-400 transition-all uppercase cursor-pointer text-sm"
                        @click="onSelectLang(itemLang)"
                    >{{ itemLang.name }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
